import React, { useEffect, useRef, useState } from "react";
import { calculateHeight } from "./utils";
import * as S from "./styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const buildPlayer = (id, token, eventListener) => {
    const video = token;
    //let heightVideo = calculateHeight();

    const player = new window.SambaPlayer(id, {
        height: "100%",
        width: "100%",
        ph: "ab581b507556a61face4d2fc75946a29",
        m: video,
        playerParams: {
            enableShare: false,
            startOutput: "360p",
            html5: localStorage.getItem("bt:html5") === "true",
            resume: true
        },
        events: eventListener
    });

    if (eventListener.onCreate) {
        eventListener.onCreate({
            play: player.play.bind(player),
            seek: player.seek.bind(player),
            pause: player.pause.bind(player)
        });
    }

    return player;
};

const SambaPlayer = ({
                         loading,
                         tokens,
                         virtualFinishAt,
                         onCreate,
                         onStart,
                         onFinish,
                         onVirtualFinish,
                         onError,
                         onListen,
                         toggleTeacherResearch,
                         id = "samba-selector"
                     }) => {
    const [loaded, setLoaded] = useState(false);
    const [firedVirtualFinish, setFiredVirtualFinish] = useState(false);
    const [listenEvent, setLastListenEvent] = useState({});
    const videoPlayerRef = useRef(null);

    useEffect(() => {
        videoPlayerRef.current.innerHTML = "";
        if (tokens.sambatech) {
            buildPlayer(id, tokens.sambatech, eventListener);
        }
    }, [tokens.sambatech]);

    useEffect(() => {
        if (onVirtualFinish && virtualFinishAt && !firedVirtualFinish) {
            const percentage = listenEvent.eventParam / (listenEvent.duration / 1000);
            if (percentage * 100 > virtualFinishAt) {
                setFiredVirtualFinish(true);
                toggleTeacherResearch(true);
                onVirtualFinish();
            }
        }
    }, [listenEvent]);

    useEffect(() => {
        setLoaded(false);
    }, [loading]);

    const _onListen = event => {
        setLastListenEvent(event);

        if (onListen) {
            onListen({
                duration: event.duration,
                seconds: event.eventParam
            });
        }
    };

    const _onError = event => {
        if (onError) {
            onError();
        }
    };

    const eventListener = {
        onCreate: onCreate,
        onLoad: () => {
            setLoaded(true);
            setFiredVirtualFinish(false);
        },
        onStart: onStart,
        onFinish: onFinish,
        onError: _onError,
        onListen: _onListen
    };
    return (
        <S.VideoPlayer>
            <S.SambaEmbed ref={videoPlayerRef} id={id}/>
            {/* Placeholder pra quando a pagina eh carregada */}
            {!loaded && !tokens.sambatech ? <div style={{ height: calculateHeight() }}/> : null}
        </S.VideoPlayer>
    );
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};

export default connect(null, mapDispatchToProps)(SambaPlayer);
